import { Dispatch, SetStateAction } from 'react';
import { AudienceInsightsDimensions } from '@blisspointmedia/bpm-types/dist/YoutubePlanning';
import { Dropdown } from '@Components/Dropdown';
import { AudienceInsightMenuItem } from './youtube-planning-types';
import { Segment } from './Segment';
import './SegmentGroup.scss';

interface SegmentGroupProps {
  title: string;
  description: string;
  targetedSegments: AudienceInsightMenuItem[];
  masterSegments: AudienceInsightMenuItem[];
  editMode: boolean;
  setTargetedSegments: Dispatch<SetStateAction<AudienceInsightMenuItem[]>>;
  onTargetedSegmentDelete: (dimension: AudienceInsightsDimensions, id: string) => void;
}

export const SegmentGroup = ({
  title,
  description,
  targetedSegments,
  masterSegments,
  editMode,
  setTargetedSegments,
  onTargetedSegmentDelete
}: SegmentGroupProps) => (
  <div className='segment-group'>
    <div className='left-container'>
      <div className='group-title-container'>
        <div className='group-title'>{title}</div>
        <div className='audience-explanation'>{description}</div>
      </div>
      {editMode && (
        <div className='select'>
          <Dropdown
            searchable
            ariaLabel={title}
            placeholder='Add additional audience'
            value={null}
            options={masterSegments.filter(
              masterSegment =>
                !targetedSegments.some(
                  targetedSegment => targetedSegment.value === masterSegment.value
                )
            )}
            onChange={value => {
              const segment = masterSegments.find(masterSegment => masterSegment.value === value);
              if (segment) {
                setTargetedSegments(prev => [segment, ...prev]);
              }
            }}
            reactSelectProps={{ isLoading: masterSegments.length === 0 }}
          />
        </div>
      )}
    </div>
    <div className='right-container'>
      {targetedSegments.map(segment => (
        <Segment
          key={segment.value}
          segment={segment}
          editMode={editMode}
          onDelete={onTargetedSegmentDelete}
        />
      ))}
    </div>
  </div>
);
